// Configuration file for Sultan Printing Center Management System
// Change these values when deploying to production

const config = {
  // Development: use proxy (relative URL) so cookies work same-origin
  development: {
    API_BASE_URL: '/api',
    FRONTEND_URL: 'http://localhost:3000'
  },

  // Production: full backend URL (cross-origin, SameSite=None cookies)
  production: {
    API_BASE_URL: 'https://sultan-printing-center-backend.onrender.com/api',
    FRONTEND_URL: 'https://www.sultan-signs.co.ke'
  }
};

// Uploads are served via authenticated API (not public static)
config.development.UPLOADS_URL = config.development.API_BASE_URL + '/uploads';
config.production.UPLOADS_URL = config.production.API_BASE_URL + '/uploads';

// Get current environment
const isDevelopment = process.env.NODE_ENV === 'development';

// Export the appropriate configuration
export const API_BASE_URL = isDevelopment ? config.development.API_BASE_URL : config.production.API_BASE_URL;
export const UPLOADS_URL = isDevelopment ? config.development.UPLOADS_URL : config.production.UPLOADS_URL;
export const FRONTEND_URL = isDevelopment ? config.development.FRONTEND_URL : config.production.FRONTEND_URL;

// For manual override (useful during deployment)
export const MANUAL_OVERRIDE = {
  API_BASE_URL: null, // Set this to override environment detection
  UPLOADS_URL: null,  // Set this to override environment detection
  FRONTEND_URL: null  // Set this to override environment detection
};

// Final URLs: env override > manual > config
export const FINAL_API_BASE_URL = process.env.REACT_APP_API_URL || MANUAL_OVERRIDE.API_BASE_URL || API_BASE_URL;
export const FINAL_UPLOADS_URL = MANUAL_OVERRIDE.UPLOADS_URL || UPLOADS_URL;
export const FINAL_FRONTEND_URL = MANUAL_OVERRIDE.FRONTEND_URL || FRONTEND_URL;

export default config; 